import { UpdateHelpCenters } from "../interfaces/help-center-interface";
import axiosInstance from "../utils/axios-instance";

export const getHelpCenterDataService = async (token: string) => {
  const response = await axiosInstance.get(
    `${process.env.REACT_APP_API_BASE_URL}/cms/helpCenter`
  );
  return response.data;
};

export const updateHelpCenterService = async (
  token: string,
  data: UpdateHelpCenters
) => {
  const response = await axiosInstance.patch(
    `${process.env.REACT_APP_API_BASE_URL}/cms/help-center`,
    data
  );
  return response.data;
};
